import { useTranslation } from "react-i18next";
import { AulaInicio, GenderLabAppShell, GenderLabBreadcrumbs } from "../../components";


export const AulaInicioPage = () => {
  const { t } = useTranslation();
  return (
    <GenderLabAppShell>
      <GenderLabBreadcrumbs
        breadcrumbs={[{ link: "", title: t("appShell.virtualClassroom") }]}
      />
      <AulaInicio />
    </GenderLabAppShell>
  );
};
